import OfficeNY from "./components/OfficeNY";
import OfficeTX from "./components/OfficeTX";
// import Home from "./components/Home";
import Container from "@mui/material/Container";
import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import awsExports from "./aws-exports";
import { I18n } from "aws-amplify";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Heading, useTheme } from "@aws-amplify/ui-react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Header from "./components/Header";
import Report from "./components/Report";
import SchedulePage from "./components/SchedulePage";

Amplify.configure(awsExports);
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV !== "development") console.log = () => {};

I18n.putVocabulariesForLanguage("en", {
  "Sign in": "Log in", // Button label
});

const components = {
  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading level={3} padding={`${tokens.space.xl} ${tokens.space.xl} 0`}>
          SCSK USA Office
        </Heading>
      );
    },
  },
};

const CNS_FONT_SIZE = 12;
const CNS_TOOLBAR_HEIGHT = 42;

function App({ signOut, user }) {
  const { mode } = "light";

  const theme = createTheme({
    components: {
      MuiTextField: {
        defaultProps: {
          variant: "outlined",
          inputProps: {
            style: {
              fontSize: CNS_FONT_SIZE,
            },
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: CNS_FONT_SIZE,
          },
        },
      },
      MuiSelect: {
        defaultProps: {
          variant: "outlined",
          MenuProps: {
            PaperProps: {
              style: {
                fontSize: CNS_FONT_SIZE,
              },
            },
          },
        },
        styleOverrides: {},
      },
    },
    palette: {
      mode: mode,
      primary: {
        // main: "#1B1F1F",
        main: "#1565c0",
      },
    },
    typography: {
      button: {
        textTransform: "none",
        fontSize: CNS_FONT_SIZE,
      },
      body1: {
        fontSize: CNS_FONT_SIZE, // MuiSelect内の文字の大きさだがAccordionのsummaryもbody1のよう
      },
      fontSize: CNS_FONT_SIZE,
    },
    mixins: {
      toolbar: {
        minHeight: CNS_TOOLBAR_HEIGHT,
        maxHeight: CNS_TOOLBAR_HEIGHT,
      },
    },
  });

  
  return (
    <ThemeProvider theme={theme}>
      <Authenticator hideSignUp={true} components={components}>
        {({ signOut, user }) => {
          // console.log(user.attributes.name)
          return (
            <main>
              <Container>
              {/* <Container maxWidth="lg"> */}
                <BrowserRouter>
                  <Header signOut={signOut} />
                  <Routes>
                    <Route
                      path="/"
                      element={<Home user={user.attributes.name} />}
                    />
                    <Route
                      path="/NY"
                      element={<OfficeNY user={user.attributes.name} />}
                    />
                    <Route
                      path="/TX"
                      element={<OfficeTX user={user.attributes.name} />}
                    />
                    <Route
                      path="/report"
                      element={<Report user={user.attributes.name} />}
                    />
                    <Route
                      path="/schedule"
                      element={<SchedulePage user={user.attributes.name} />}
                    />
                  </Routes>
                </BrowserRouter>
              </Container>
            </main>
          );
        }}
      </Authenticator>
    </ThemeProvider>
  );
}

export default App;
